import { Nullable } from 'global';
import { DeskingSubmitOptions } from 'modules/desking/types';
import { equipmentMileageFormatter } from '../../desking';

export function collectEquipmentDTO(
  equipment: DeskingSubmitOptions['form']['equipment']
): Nullable<Record<string, any>[]> {
  const {
    serialNumberVin,
    class: classType,
    selectedEquipment,
    description: additionalDescription,
    totalWholesaleCost,
    retailPrice,
    ...equipmentDTO
  } = equipment;

  return [
    {
      ...equipmentDTO,
      classType,
      additionalDescription,
      year: equipmentDTO.year.toString(),
      retailPrice: Number(retailPrice || 0),
      serialNumberVin: serialNumberVin?.trim(),
      quantity: Number(equipmentDTO.quantity || 1),
      totalWholesaleCost: totalWholesaleCost || 0,
      mileage: equipmentMileageFormatter(equipmentDTO.mileage, 'toInt'),
    },
  ];
}
